'use strict';

/**
 * Convert a number into a string and add commas every
 * 3 digits. If there are decimals, the number will be
 * treated as a currency unless 'notCurrency' param is
 * false.
 * @param {String|Number} number String representation of a number or a normal number
 * @param {Boolean} notCurrency If the number should not be treated like a currency for decimals
 * @param {String} delim Indicates what symbol should separate every 3 digits; Either a ',' or a '.'
 * @return {String}
 */

var DELIM_COMMA = ',';
var DELIM_PERIOD = '.';

function numAddCommas(number, notCurrency, delim) {

    var i = void 0;
    var len = void 0;
    var dec = '';
    var newNum = '';
    var decIndx = void 0;
    var decimalDelim = void 0;

    delim = delim || DELIM_COMMA;
    decimalDelim = delim === DELIM_COMMA ? DELIM_PERIOD : DELIM_COMMA;

    if (!number && number !== 0) {
        return '';
    }

    number = '' + number;

    if (number.indexOf(delim) !== -1) {
        number = number.replace(new RegExp(delim, 'g'), '');
    }

    decIndx = number.indexOf(decimalDelim);
    if (decIndx !== -1) {
        len = number.length;
        if (notCurrency) {
            dec = number.substring(decIndx, len);
        } else {
            var numSubstring = delim === DELIM_PERIOD ? delim + number.substring(decIndx + 1) : number.substring(decIndx);
            dec = ('' + Math.round(Number(numSubstring) * 100) / 100).substring(1);
            dec = delim === DELIM_PERIOD ? dec.replace(DELIM_PERIOD, DELIM_COMMA) : dec;
            if (dec.length > 3) {
                dec = dec.substring(0, 3);
            } else if (dec.length === 2) {
                dec = dec + '0';
            }
        }
        number = number.substring(0, decIndx);
    }

    len = number.length;
    i = len - 1;

    while (i >= 0) {
        newNum = number.charAt(i) + newNum;

        if ((len - i) % 3 === 0 && len - 1 !== i && i > 0) {
            newNum = delim + newNum;
        }

        i = i - 1;
    }

    return newNum + dec;
}

module.exports = numAddCommas;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-num-add-commas/dist/index.js
// module id = 127
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55